import { ACTIONS } from '../constants';

/* addons expected to be an associative array with addon type as the key.
example: { [ADDONS.DEDICATED_IP]: { type: ADDONS.DEDICATED_IP, num: 2 }}
*/
export const addAddons = addons => ({ type: ACTIONS.ADD_ADDON, addons });

export const removeAddon = addon => ({ type: ACTIONS.REMOVE_ADDON, addon });



// WEBPACK FOOTER //
// ./src/actions/addOns.js